// Scene & Layout Constants
export const SCENE = {
    WIDTH: 1440,              // Scene width in pixels
    HEIGHT: 650,              // Scene height in pixels
    ASPECT_RATIO: 2.2154,     // Scene aspect ratio
    MAX_CONSTELLATION_WIDTH: 1320  // Maximum width for card constellation
};

// Texture Atlas Constants
export const ATLAS = {
    WIDTH: 2048,             // Width of the texture atlas
    HEIGHT: 2048             // Height of the texture atlas
};

// Card Layout Data
export const CARDS_DATA = {
    "01.png": {
        frame: { x: 30, y: 30, w: 364, h: 428 },
        world: { x: 71, y: 10, order: 19, batch: 3, rotation: -23 }
    },
    "02.png": {
        frame: { x: 30, y: 518, w: 364, h: 428 },
        world: { x: 272, y: 11, order: 26, batch: 4, rotation: 12 }
    },
    "03.png": {
        frame: { x: 454, y: 30, w: 364, h: 428 },
        world: { x: 504, y: 0, order: 27, batch: 5, rotation: -12 }
    },
    "04.png": {
        frame: { x: 30, y: 1006, w: 364, h: 428 },
        world: { x: 669, y: 84, order: 9, batch: 2, rotation: 13 }
    },
    "05.png": {
        frame: { x: 454, y: 518, w: 364, h: 428 },
        world: { x: 902, y: 32, order: 16, batch: 3, rotation: -9.7 }
    },
    "06.png": {
        frame: { x: 878, y: 30, w: 364, h: 428 },
        world: { x: 121, y: 176, order: 14, batch: 2, rotation: 14.2 }
    },
    "07.png": {
        frame: { x: 30, y: 1494, w: 364, h: 428 },
        world: { x: 338, y: 176, order: 15, batch: 3, rotation: -5 }
    },
    "08.png": {
        frame: { x: 454, y: 1006, w: 364, h: 428 },
        world: { x: 540, y: 200, order: 11, batch: 2, rotation: -13.7 }
    },
    "09.png": {
        frame: { x: 878, y: 518, w: 364, h: 428 },
        world: { x: 687, y: 339, order: 14, batch: 3, rotation: 14.1 }
    },
    "10.png": {
        frame: { x: 1302, y: 30, w: 364, h: 428 },
        world: { x: 797, y: 206, order: 44, batch: 5, rotation: 2 }
    },
    "11.png": {
        frame: { x: 454, y: 1494, w: 364, h: 428 },
        world: { x: 42, y: 351, order: 1, batch: 1, rotation: 5 }
    },
    "12.png": {
        frame: { x: 878, y: 1006, w: 364, h: 428 },
        world: { x: 190, y: 320, order: 18, batch: 3, rotation: -9 }
    },
    "13.png": {
        frame: { x: 1302, y: 518, w: 364, h: 428 },
        world: { x: 367, y: 358, order: 24, batch: 4, rotation: 18.9 }
    },
    "14.png": {
        frame: { x: 878, y: 1494, w: 364, h: 428 },
        world: { x: 560, y: 391, order: 12, batch: 2, rotation: -11.93 }
    },
    "15.png": {
        frame: { x: 1302, y: 1006, w: 364, h: 428 },
        world: { x: 882, y: 338, order: 10, batch: 2, rotation: -17.6 }
    }
};

// Card Dimensions (common for all cards)
export const CARD = {
    WIDTH: 364,              // Card width in atlas
    HEIGHT: 428              // Card height in atlas
};

// Force & Interaction Parameters
export const FORCE_STRENGTH = 4000.0;    // Base multiplier for mouse/touch force
export const INFLUENCE_FALLOFF = 1.2;    // How quickly force weakens with distance
export const MAX_DISTANCE = 1.0;         // Maximum distance cards can be affected

// Velocity & Movement Parameters
export const DAMPING = 0.985;           // Velocity preservation per frame
export const MIN_VELOCITY = 0.04;       // Velocity threshold to stop movement
export const MAX_VELOCITY = 30.0;       // Maximum speed limit for cards

// Return & Stabilization
export const RETURN_SPEED = 0.2;        // Speed of return to original positions
export const RETURN_VELOCITY_THRESHOLD = 0.2; // Speed to start returning
export const DEBOUNCE_TIME = 0.5;       // Cooldown time between interactions

// Input Device Sensitivity
export const MOVEMENT_SCALE = 2.0;      // Base mouse movement multiplier
export const TRACKPAD_SCALE = 5.0;      // Additional multiplier for trackpad
export const MAX_DELTA = 0.3;           // Maximum allowed movement per frame

// Shockwave Effect (Click/Tap)
export const SHOCKWAVE_STRENGTH = 4000.0;  // Base power of shockwave impulse
export const SHOCKWAVE_RADIUS = 4.5;       // Radius of shockwave effect
export const SHOCKWAVE_FALLOFF = 1.5;      // How quickly shockwave weakens
export const SHOCKWAVE_DECAY = 0.15;       // How quickly shockwave fades

// Parameter Ranges for Debug Controls
export const PARAM_RANGES = {
    forceStrength: [500, 5000],
    influenceFalloff: [0.1, 5.0],
    maxDistance: [0.1, 3.0],
    damping: [0.8, 0.999],
    minVelocity: [0.001, 0.1],
    maxVelocity: [1, 50],
    returnSpeed: [0.05, 2.0],
    returnVelocityThreshold: [0.1, 5.0],
    debounceTime: [0.05, 2.0],
    movementScale: [0.1, 10.0],
    trackpadScale: [0.1, 10.0],
    maxDelta: [0.01, 1.0],
    shockwaveStrength: [1000, 10000],
    shockwaveRadius: [0.5, 5.0],
    shockwaveFalloff: [0.1, 2.0],
    shockwaveDecay: [0.05, 0.5]
};
